export default "__VITE_ASSET__343a3a2a__"